import type { CoverDoc } from 'fym-shared/src/music24/coverDoc';
import { LOCAL_CARRY } from '../publicMode/publicCoverStore';

/** Where a carried design comes from: the saved design of a lead, the design of this browser, or none. */
export type CoverCarrySource = { kind: 'lead'; token: string } | { kind: 'local' } | { kind: 'none' };

/** The source of a carried design from the stored carry value. Pure. */
export function coverCarrySource(carry: string | null): CoverCarrySource {
  if (carry === null) {
    return { kind: 'none' };
  }
  return carry === LOCAL_CARRY ? { kind: 'local' } : { kind: 'lead', token: carry };
}

/**
 * The carried design on a song: the title and artist boxes take the title and the artist of the
 * song (the visitor typed them in the public tool, the song has its own), every other box and the
 * look stay. Pure.
 */
export function carriedDocForSong(doc: CoverDoc, song: { title: string; artistName: string }): CoverDoc {
  return {
    ...doc,
    texts: doc.texts.map((box) => {
      if (box.role === 'title' && song.title.trim() !== '') {
        return { ...box, text: song.title };
      }
      if (box.role === 'artist' && song.artistName.trim() !== '') {
        return { ...box, text: song.artistName };
      }
      return box;
    }),
  };
}

/**
 * The next step after a sign-in with a carried design (design g4): nothing to carry → Home; no
 * song yet → add a release first; else choose the song. Pure.
 */
export function carryStep(input: { hasDesign: boolean; songCount: number }): 'home' | 'addSong' | 'choose' {
  if (!input.hasDesign) {
    return 'home';
  }
  return input.songCount === 0 ? 'addSong' : 'choose';
}
